<template>
  <div>
    <b-card title="Device">
      <hr>
      <b-row
        xl="12"
        sm="12"
      >
        <b-col
          cols="12"
          md="3"
          class="mb-md-0 mb-2"
          style="display: none;"
        >
          <v-select
            id="v-Province"
            v-model="select_6"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="ProvinceOptions"
            :reduce="ProvinceOptions => ProvinceOptions.value"
            label="title"
            placeholder="--Select Province --"
            class="w-100"
          />
        </b-col>
        <b-col
          cols="12"
          md="3"
          class="mb-md-0 mb-2"
          style="display: none;"
        >
          <v-select
            id="v-Regency"
            v-model="select_7"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="RegencyOptions"
            :reduce="RegencyOptions => RegencyOptions.value"
            label="title"
            placeholder="--Select Regency --"
            class="w-100"
          />
        </b-col>
        <b-col
          cols="12"
          md="4"
          class="mb-md-0 mb-2"
          style="display: none;"
        >
          <v-select
            id="v-District"
            v-model="select_8"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="DistrictOptions"
            :reduce="DistrictOptions => DistrictOptions.value"
            label="title"
            placeholder="--Select District --"
            class="w-100"
          />
        </b-col>
        <b-col
          cols="12"
          md="3"
          class="mb-md-0 mb-2"
        >
          <v-select
            v-model="select_site"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="SiteOptions"
            :reduce="SiteOptions => SiteOptions.value"
            label="title"
            placeholder="Site"
            class="w-100"
          />
        </b-col>
        <b-col
          cols="12"
          md="3"
          class="mb-md-0 mb-2"
        >
          <v-select
            v-model="select_device"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="deviceOptionsFiltered"
            :reduce="DeviceOptions => DeviceOptions.value"
            label="title"
            placeholder="Device"
            class="w-100"
            @input="changeDate()"
          />
        </b-col>
      </b-row>
    </b-card>
    <b-card title="Filter">
      <hr>
      <b-row
        xl="12"
        sm="12"
      >
        <b-col
          cols="12"
          md="3"
          class="mb-md-0 mb-2"
        >
          <v-select
            v-model="statusFilter_Temperature"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            label="title"
            :options="statusOptions"
            :reduce="statusOptions => statusOptions.value"
            class="w-100"
            @input="changeDate()"
          />
        </b-col>
        <b-col
          cols="12"
          md="3"
          class="mb-md-0 mb-2"
          :hidden="statusFilter_Temperature === 'A'"
        >
          <b-input-group>
            <flat-pickr
              v-model="date_start"
              class="form-control"
              :config="{ enableTime: false, time_24hr: false, }"
              placeholder="DD-MM-YYYY"
              :disabled="statusFilter_Temperature === 'A'"
              @input="changeDate()"
            />
            <b-input-group-append is-text>
              <feather-icon
                icon="CalendarIcon"
                class="cursor-pointer"
              />
              <b>&nbsp;Start</b>
            </b-input-group-append>
          </b-input-group>
        </b-col>
        <b-col
          cols="12"
          md="3"
          class="mb-md-0 mb-2"
          :hidden="statusFilter_Temperature === 'A'"
        >
          <b-input-group>
            <flat-pickr
              v-model="date_finish"
              class="form-control"
              :config="{ enableTime: false, time_24hr: false, }"
              placeholder="DD-MM-YYYY"
              :disabled="statusFilter_Temperature === 'A'"
              @input="changeDate()"
            />
            <b-input-group-append is-text>
              <feather-icon
                icon="ClockIcon"
                class="cursor-pointer"
              />
              <b>&nbsp;Finish</b>
            </b-input-group-append>
          </b-input-group>
        </b-col>
        <b-col
          cols="12"
          md="3"
          class="mb-md-0 mb-2"
        >
          <b-button
            v-ripple.400="'rgba(113, 102, 240, 0.15)'"
            class="sidebar-center"
            variant="primary"
            @click="changeDate()"
          >
            <feather-icon icon="SearchIcon" /> Filter
          </b-button>
        </b-col>
      </b-row>
    </b-card>

    <b-card title="Sparing">
      <hr>
      <b-row>
        <b-col
          v-if="!isRpsm"
          cols="12"
          md="3"
          class="mb-md-0 mb-2"
        >
          <br>
          <br>
          <br>
          <!-- apex chart -->
          <vue-apex-charts
            type="radialBar"
            height="20"
            class="my-2"
            :options="goalOverviewRadialBarTemperature"
            :series="[]"
          />
          <h1 class="text-center">
            {{ realtime_sparing.value }} {{ realtime_sparing.value_default_unit }}
          </h1>
          <b-row class="text-center mx-0">
            <b-col
              cols="6"
              class="border-top border-right d-flex align-items-between flex-column py-1"
            >
              <h3 class="font-weight-bolder mb-0">
                {{ realtime_sparing.value_min }} {{ realtime_sparing.value_default_unit }}
              </h3>
            </b-col>

            <b-col
              cols="6"
              class="border-top d-flex align-items-between flex-column py-1"
            >

              <h3 class="font-weight-bolder mb-0">
                {{ realtime_sparing.value_max }} {{ realtime_sparing.value_default_unit }}
              </h3>
            </b-col>
          </b-row>
        </b-col>
        <b-col
          cols="12"
          :md="isRpsm ? 12 : 9"
          class="mb-md-0 mb-2"
        >
          <b-card-body>
            <vue-apex-charts
              type="line"
              height="400"
              :options="lineChartSimpleTemperature.chartOptions"
              :series="lineChartSimpleTemperature.series"
            />
          </b-card-body>
        </b-col>
      </b-row>
    </b-card>
    <!-- Table -->
    <b-card>
      <div>
        <b-button
          v-ripple.400="'rgba(113, 102, 240, 0.15)'"
          class="ml-1 mb-1"
          variant="outline-primary"
          @click="exportExcelTemperature"
        >
          <feather-icon icon="DownloadIcon" /> Export
        </b-button>
      </div>
      <div>
        <div class="h-50 d-inline-block" />
      </div>
      <div class="d-none justify-content-between flex-wrap">
        <!-- sorting  -->
        <b-form-group
          label="Sort"
          label-size="sm"
          label-align-sm="left"
          label-cols-sm="3"
          label-for="sortBySelect"
          class="ml-1"
        >
          <b-input-group size="sm">
            <b-form-select
              id="sortBySelect"
              v-model="sortBy_Temperature"
              :options="sortOptions_Temperature"
            >
              <template #first>
                <option value="">
                  none
                </option>
              </template>
            </b-form-select>
            <b-form-select
              v-model="sortDesc_Temperature"
              size="sm"
              :disabled="!sortBy_Temperature"
            >
              <option :value="false">
                Asc
              </option>
              <option :value="true">
                Desc
              </option>
            </b-form-select>
          </b-input-group>
        </b-form-group>

        <!-- filter -->
        <b-form-group
          label="Filter"
          label-cols-sm="3"
          label-align-sm="left"
          label-size="sm"
          label-for="filterInput"
          class="ml-1"
        >
          <b-input-group size="sm">
            <b-form-input
              id="filterInput"
              v-model="filter_Temperature"
              type="search"
              placeholder="Type to Search"
            />
            <b-input-group-append>
              <b-button
                :disabled="!filter_Temperature"
                @click="filter_Temperature = ''"
              >
                Clear
              </b-button>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </div>
      <b-table
        striped
        hover
        responsive
        class="position-relative"
        :items="historical_temperature"
        :fields="fields_Temperature"
        @sort-changed="sortChanged"
      >
        <template #cell(recorded_at)="data">
          {{ dateFormat(data.value) }}
        </template>
        <template #cell(value)="row">
          {{ row.item.value }}
        </template>
        <template #cell(status)="data">
          <b-badge :variant="status[1][data.value]">
            {{ status[0][data.value] }}
          </b-badge>
        </template>
      </b-table>
      <b-card-body>
        <Pagination
          :current-page.sync="currentPage_Temperature"
          :per-page.sync="perPage"
          :total-rows="totalRows_Temperature"
          @filter="handleFilter"
        />
      </b-card-body>
    </b-card>
  </div>
</template>
<script>
import {
  BCard, BTable, BInputGroup, BInputGroupAppend, BCardBody, BButton, BBadge, BFormGroup, BFormInput, BFormSelect, BRow, BCol,
} from 'bootstrap-vue'
import { mapState } from 'vuex'
import Ripple from 'vue-ripple-directive'
import moment from 'moment'
import VueApexCharts from 'vue-apexcharts'
import useAppConfig from '@core/app-config/useAppConfig'
import { computed, watch } from '@vue/composition-api'
import flatPickr from 'vue-flatpickr-component'
import vSelect from 'vue-select'
import { $themeColors } from '@themeConfig'
import XLSX from 'xlsx'
import useJwt from '@/auth/jwt/useJwt'
import Pagination from '@/views/general/components/Pagination.vue'

const $strokeColor = '#ebe9f1'
const $textHeadingColor = '#5e5873'
const $goalStrokeColor2 = '#51e5a8'
export default {
  components: {
    vSelect, flatPickr, VueApexCharts, BCard, BTable, BBadge, BFormGroup, BFormSelect, BInputGroup, BFormInput, BInputGroupAppend, BButton, BCardBody, BRow, BCol, Pagination,
  },
  setup() {
    const { skin } = useAppConfig()

    const isDark = computed(() => skin.value === 'dark')
    watch(isDark, (newValue, oldValue) => {
      if (newValue !== oldValue) {
        // Memuat ulang halaman saat nilai isDark berubah
        window.location.reload()
      }
    })
    return { skin, isDark }
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      goalOverviewRadialBarTemperature: {
        chart: {
          height: 245,
          type: 'radialBar',
          sparkline: {
            enabled: false,
          },
          dropShadow: {
            enabled: true,
            blur: 3,
            left: 1,
            top: 1,
            opacity: 0.1,
          },
        },
        colors: [$goalStrokeColor2],
        plotOptions: {
          radialBar: {
            offsetY: -10,
            startAngle: -150,
            endAngle: 150,
            hollow: {
              size: '77%',
            },
            background: $strokeColor,
            dataLabels: {
              name: {
                show: false,
              },
              value: {
                color: $textHeadingColor,
                fontSize: '2.86rem',
                fontWeight: '600',
                formatter: val => val.toFixed(3),
              },
            },
          },
        },
        fill: {
          type: 'gradient',
          gradient: {
            shade: 'dark',
            type: 'horizontal',
            shadeIntensity: 0.5,
            // gradientToColors: [$themeColors.success],
            inverseColors: true,
            opacityFrom: 1,
            opacityTo: 1,
            stops: [0, 100],
          },
        },
        stroke: {
          lineCap: 'round',
        },
        grid: {
          padding: {
            bottom: 30,
          },
        },
      },
      goalOverviewRadialBarBattery: {
        chart: {
          height: 245,
          type: 'radialBar',
          sparkline: {
            enabled: true,
          },
          dropShadow: {
            enabled: true,
            blur: 3,
            left: 1,
            top: 1,
            opacity: 0.1,
          },
        },
        colors: [$goalStrokeColor2],
        plotOptions: {
          radialBar: {
            offsetY: -10,
            startAngle: -150,
            endAngle: 150,
            hollow: {
              size: '77%',
            },
            track: {
              background: $strokeColor,
              strokeWidth: '50%',
            },
            dataLabels: {
              name: {
                show: false,
              },
              value: {
                color: $textHeadingColor,
                fontSize: '2.86rem',
                fontWeight: '600',
              },
            },
          },
        },
        fill: {
          type: 'gradient',
          gradient: {
            shade: 'dark',
            type: 'horizontal',
            shadeIntensity: 0.5,
            gradientToColors: [$themeColors.success],
            inverseColors: true,
            opacityFrom: 1,
            opacityTo: 1,
            stops: [0, 100],
          },
        },
        stroke: {
          lineCap: 'round',
        },
        grid: {
          padding: {
            bottom: 30,
          },
        },
      },
      lineChartSimpleTemperature: {
        series: [
          {
            name: 'Temperature',
            data: [],
          },
        ],
        chartOptions: {
          chart: {
            zoom: {
              enabled: false,
            },
            toolbar: {
              show: false,
            },
          },
          markers: {
            strokeWidth: 7,
            strokeOpacity: 1,
            strokeColors: [$themeColors.light],
            colors: [$themeColors.warning],
          },
          colors: ['#28C76F', '#247BA0', '#EA5455'],
          dataLabels: {
            enabled: false,
          },
          stroke: {
            curve: 'straight',
          },
          grid: {
            xaxis: {
              areas: {
                show: true,
              },
            },
          },
          tooltip: {
            custom(data) {
              return `${'<div class="px-1 py-50"><span>'}${data.series[data.seriesIndex][data.dataPointIndex]
              }</span></div>`
            },
          },
          xaxis: {
            categories: [],
            labels: {
              style: {
                colors: '',
              },
            },
          },
        },
      },
      lineChartSimpleBattery: {
        series: [
          {
            name: 'Battery Power',
            data: [],
          },
        ],
        chartOptions: {
          chart: {
            zoom: {
              enabled: false,
            },
            toolbar: {
              show: false,
            },
          },
          markers: {
            strokeWidth: 7,
            strokeOpacity: 1,
            strokeColors: [$themeColors.light],
            colors: [$themeColors.warning],
          },
          colors: ['#28C76F', '#247BA0', '#EA5455'],
          dataLabels: {
            enabled: false,
          },
          stroke: {
            curve: 'straight',
          },
          grid: {
            xaxis: {
              lines: {
                show: true,
              },
            },
          },
          tooltip: {
            custom(data) {
              return `${'<div class="px-1 py-50"><span>'}${data.series[data.seriesIndex][data.dataPointIndex]
              }</span></div>`
            },
          },
          xaxis: {
            categories: [],
            labels: {
              style: {
                colors: '',
              },
            },
          },
          yaxis: {
            // opposite: isRtl,
          },
        },
      },
      date_start: moment(String(new Date())).format('YYYY-MM-DD'),
      date_finish: moment(String(new Date())).format('YYYY-MM-DD'),
      select_6: '',
      select_7: '',
      select_8: '',
      select_9: '',
      select_device: '',
      select_site: null,
      show: false,
      dir: false,
      realtime_sparing: {
        value: null,
        value_default_unit: null,
        value_max: null,
        value_min: null,
      },
      realtime_battery: {
        value: [],
        value_default_unit: null,
        value_max: null,
        value_min: null,
      },
      currentPage_Temperature: 1,
      sortBy_Temperature: '',
      DefaultDevice: '',
      sortDesc_Temperature: false,
      sortDirection_Temperature: 'asc',
      perPage: 10,
      filter_Temperature: null,
      filterOn_Temperature: [],
      currentPage_Battery: 1,
      sortBy_Battery: '',
      sortDesc_Battery: false,
      sortDirection_Battery: 'asc',
      filter_Battery: null,
      filterOn_Battery: [],
      infoModal: {
        id: 'info-modal',
        title: '',
        content: '',
      },
      statusFilter_Temperature: 'A',
      statusFilter_Battery: 'AC',
      status: [{
        AC: 'Active', 2: 'Professional', 3: 'Rejected', 4: 'Resigned', 5: 'Applied',
      },
      {
        AC: 'light-primary', 2: 'light-success', 3: 'light-danger', 4: 'light-warning', 5: 'light-info',
      }],
      statusOptions: [
        { title: 'Realtime', value: 'A' },
        { title: 'History', value: 'M' },
      ],
      trendInterval: null,
      deviceName: '',
    }
  },
  computed: {
    ...mapState({
      ProvinceOptions: state => state.region.province,
      RegencyOptions: state => state.region.regency,
      DistrictOptions: state => state.region.district,
      SiteOptions: state => state.site.options,
      DeviceOptions: state => state.site.optionsdevice,
      LocationOptions: state => state.location.options,
      trend: state => state.temperature.trend,
      fields_Temperature: state => state.temperature.fields_Temperature,
      totalRows_Temperature: state => state.temperature.totalRows_Temperature,
      historical_temperature: state => state.temperature.historical_temperature,
      historical_temperature_full: state => state.temperature.historical_temperature_full,
      perPage_Temperature: state => state.temperature.perPage_Temperature,
      pageOptions_Temperature: state => state.temperature.pageOptions_Temperature,
      fields_Battery: state => state.temperature.fields_Battery,
      historical_battery: state => state.temperature.historical_battery,
      totalRows_Battery: state => state.temperature.totalRows_Battery,
      perPage_Battery: state => state.temperature.perPage_Battery,
      pageOptions_Battery: state => state.temperature.pageOptions_Battery,
    }),
    isRpsm() {
      return this.deviceName === 'alarm' || this.deviceName === 'ups' || this.deviceName === 'pln'
    },
    deviceOptionsFiltered() {
      const additionals = ['pln', 'ups', 'totalizer', 'rssi', 'provider', 'alarm']
      return this.DeviceOptions.filter(item => !additionals.includes(item.title.toLowerCase()))
    },
    series() {
      const { value } = this.realtime_sparing
      return [value]
    },
    sortOptions_Temperature() {
      // Create an options list from our fields
      return this.fields_Temperature
        .filter(f => f.sortable)
        .map(f => ({ text: f.label, value: f.key }))
    },
    sortOptions_Battery() {
      // Create an options list from our fields
      return this.fields_Battery
        .filter(f => f.sortable)
        .map(f => ({ text: f.label, value: f.key }))
    },
    dateFormat() {
      return createdAt => this.$options.filters.formatDate(createdAt)
    },
    dateFormatLocal() {
      return createdAt => moment(createdAt).format('DD-MM-YYYY HH:mm')
    },

  },
  watch: {
    select_6(obj) {
      this.$store.dispatch('region/regency', obj)
      this.$store.dispatch('site/setFilterProvince', obj)
      this.select_7 = ''
    },
    select_7(obj) {
      this.$store.dispatch('site/setFilterRegency', obj)
      this.select_site = ''
    },
    select_site(obj) {
      this.$store.dispatch('site/setFilterSiteSparing', obj)
    },
  },
  mounted() {
    // Set the initial number of items
    this.$store.state.totalRows_Temperature = this.historical_temperature.length
    this.$store.state.totalRows_Battery = this.historical_battery.length
  },
  async created() {
    this.$store.dispatch('site/setFilterSiteSparing', '')
    // this.$store.dispatch('site/getAll')
    this.$store.dispatch('location/getAll')
    this.$store.dispatch('region/province')
    this.$store.dispatch('site/setFilterRegencySparing', '')
    // this.$store.dispatch('device/getAll')
    this.$store.dispatch('temperature/getDeviceInstallSparing')
    if (this.isDark === true) {
      this.lineChartSimpleTemperature.chartOptions.xaxis.labels.style.colors = '#ffffff'
    }

    if (this.$route.params.id) {
      this.getData(this.$route.params.id)
    } else {
      const project = this.$store.state.user?.ProjectOptions
      const isRpsm = project && project.length > 0 ? project[0].name.toLowerCase() === 'rpsm' : false
      let res = null

      if (isRpsm) {
        res = await this.$store.dispatch('site/getDefaultDeviceSparingFiltered')
      } else {
        res = await this.$store.dispatch('site/getDefaultDeviceSparing')
      }
      if (res) {
        this.DefaultDevice = res.device_id
        this.getData(this.DefaultDevice)
      }
    }
  },
  beforeDestroy() {
    if (this.trendInterval) clearInterval(this.trendInterval)
  },
  methods: {
    handleFilter(currentPage, perPage) {
      this.currentPage_Temperature = currentPage
      this.perPage = perPage
      this.getData()
    },
    sortChanged({ sortBy, sortDesc, sortDirection }) {
      this.sortBy_Temperature = sortBy
      this.sortDesc_Temperature = sortDesc
      this.sortDirection_Temperature = sortDirection
      this.getData()
    },
    valueToPercent(val) {
      return (val * 100)
      // const percentage = ((val - minValue) * 100) / (maxValue - minValue)
      // return percentage.toLocaleString(undefined, { minimumFractionDigits: 3, maximumFractionDigits: 3 })
      // return ((val - minValue) * 100) / (maxValue - minValue)
      // return ((val - this.realtime_sparing.value_min) * 100 ) / (this.realtime_sparing.value_max - this.realtime_sparing.value_min)
    },
    info(item, index, button) {
      this.infoModal.title = `Row index: ${index}`
      this.infoModal.content = JSON.stringify(item, null, 2)
      this.$root.$emit('bv::show::modal', this.infoModal.id, button)
    },
    resetInfoModal() {
      this.infoModal.title = ''
      this.infoModal.content = ''
    },
    onFiltered_Temperature(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.$store.state.totalRows_Temperature = filteredItems.length
      this.currentPage_Temperature = 1
    },
    onFiltered_Battery(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.$store.state.totalRows_Battery = filteredItems.length
      this.currentPage_Battery = 1
    },
    advanceSearch(val) {
      this.searchTerm = val
    },
    moment(date) {
      return moment(date)
    },
    changeDate() {
      this.getData()
    },
    getData(id) {
      this.show = true
      this.startmoments = this.date_start
      this.endmoments = this.date_finish
      const orderBy = this.sortBy_Temperature ? JSON.stringify({ [this.sortBy_Temperature]: this.sortDesc_Temperature ? 'desc' : 'asc' }) : ''

      if (id) {
        this.device_id = id
      } else {
        this.device_id = this.select_device
      }
      this.params = {
        datestart: moment(this.startmoments, 'YYYY-MM-DD').utc().toISOString(),
        datefinish: moment(this.endmoments, 'YYYY-MM-DD').add(23, 'hours').add(59, 'minutes').utc()
          .toISOString(),
        device_id: this.device_id,
        status: this.statusFilter_Temperature,
        site_id: this.select_site,
        page: this.currentPage_Temperature,
        limit: this.perPage,
      }

      if (orderBy) {
        this.params.orderBy = orderBy
      }

      if (this.statusFilter_Temperature === 'A') {
        this.$store.dispatch('temperature/getAllSparing', this.params).then(resp => {
          this.injectData(resp)
        })
        if (this.trendInterval) clearInterval(this.trendInterval)
        this.trendInterval = setInterval(() => {
          this.$store.dispatch('temperature/getAllSparing', this.params).then(resp => {
            this.injectData(resp)
          })
        }, 60000)
      }
      if (this.statusFilter_Temperature === 'M') {
        this.$store.dispatch('temperature/getAllSparing', this.params).then(resp => {
          this.injectData(resp)
        })
      }
    },

    getFullData(id) {
      return new Promise((resolve, reject) => {
        this.show = true
        this.startmoments = this.date_start
        this.endmoments = this.date_finish
        const orderBy = this.sortBy_Temperature ? JSON.stringify({ [this.sortBy_Temperature]: this.sortDesc_Temperature ? 'desc' : 'asc' }) : ''

        if (id) {
          this.device_id = id
        } else {
          this.device_id = this.select_device
        }
        this.params = {
          datestart: moment(this.startmoments, 'YYYY-MM-DD').utc().toISOString(),
          datefinish: moment(this.endmoments, 'YYYY-MM-DD').add(23, 'hours').add(59, 'minutes').utc()
            .toISOString(),
          device_id: this.device_id,
          status: this.statusFilter_Temperature,
          site_id: this.select_site,
        }

        if (orderBy) {
          this.params.orderBy = orderBy
        }

        if (this.statusFilter_Temperature === 'A') {
          this.$store.dispatch('temperature/getSparingFullData', this.params).then(resp => {
            resolve(resp)
          }).catch(reject)
          if (this.trendInterval) clearInterval(this.trendInterval)
          this.trendInterval = setInterval(() => {
            this.$store.dispatch('temperature/getSparingFullData', this.params)
          }, 60000)
        } else if (this.statusFilter_Temperature === 'M') {
          this.$store.dispatch('temperature/getSparingFullData', this.params).then(resp => {
            resolve(resp)
          }).catch(reject)
        } else {
          resolve()
        }
      })
    },
    injectData(resp) {
      const temperatureValue = []
      const temperatureTime = []
      this.deviceName = resp.information.device_name.toLowerCase()
      this.realtime_sparing.value = resp.realtime_sparing.value
      this.realtime_sparing.value_default_unit = resp.realtime_sparing.value_default_unit
      this.maxValues = resp.realtime_sparing.value_max
      this.realtime_sparing.value_max = resp.realtime_sparing.value_max
      this.realtime_sparing.value_min = resp.realtime_sparing.value_min
      if (this.DefaultDevice) {
        this.select_device = resp.information.device_id
      }
      if (resp.historical_sparing.length) {
        // eslint-disable-next-line no-plusplus
        for (let x = 0; x < resp.historical_sparing.length; x++) {
          temperatureValue[x] = parseFloat(resp.historical_sparing[x].value)
          temperatureTime[x] = this.$options.filters.formatDate(resp.historical_sparing[x].recorded_at)
        }
        temperatureValue.push()
        temperatureTime.push()
        this.lineChartSimpleTemperature.series[0] = {
          name: 'Sparing',
          data: temperatureValue,
        }
        this.lineChartSimpleTemperature.chartOptions = {
          xaxis: {
            categories: temperatureTime,
            labels: {
              style: {
                colors: this.isDark ? '#ffffff' : '#000000',
              },
            },
          },
          yaxis: {
            min: this.realtime_sparing.value_min,
            max: this.realtime_sparing.value_max,
            labels: {
              style: {
                colors: this.isDark ? '#ffffff' : '#000000',
              },
            },
          },
        }
        this.lineChartSimpleTemperature.chartOptions.annotations = {
          yaxis: [{
            y: this.realtime_sparing.value_max,
            borderColor: '#EF0E31',
            borderWidth: 3,
            strokeDashArray: 3,
            label: {
              borderColor: '#EF0E31',
              style: {
                color: '#fff',
                background: '#EF0E31',
              },
              text: 'MAX VALUE',
            },
          },
          {
            y: this.realtime_sparing.value_min,
            borderColor: '#EF0E31',
            borderWidth: 3,
            strokeDashArray: 3,
            label: {
              borderColor: '#EF0E31',
              style: {
                color: '#fff',
                background: '#EF0E31',
              },
              text: 'MIN 2VALUE',
            },
          }],
        }
      }
      this.show = false
    },
    async exportExcelTemperature() {
      await this.getFullData()
      let nameProject = ''
      useJwt.getProfile().then(response => {
        nameProject = response.data.data.user_projects[0].projects.name
        const jsons = []
        if (this.select_device === 1083) {
          this.select_device = 'TSS'
        }
        if (this.select_device === 1081) {
          this.select_device = 'PH'
        }
        if (this.select_device === 1084) {
          this.select_device = 'NH3N'
        }
        if (this.select_device === 1082) {
          this.select_device = 'COD'
        }
        if (this.select_device === 1085) {
          this.select_device = 'Debit'
        }
        // eslint-disable-next-line no-plusplus
        for (let x = 0; x < this.historical_temperature_full.length; x++) {
          jsons[x] = {
            Project: `${nameProject}_Trend`,
            Parameter: this.select_device,
            datetime: moment(String(this.historical_temperature_full[x].recorded_at)).format('DD-MM-YYYY HH:mm:ss'),
            value: this.historical_temperature_full[x].value + this.historical_temperature_full[x].value_default_unit,
          }
        }
        const dataJson = XLSX.utils.json_to_sheet(jsons)
        const wb = XLSX.utils.book_new()
        XLSX.utils.book_append_sheet(wb, dataJson, 'data')
        XLSX.writeFile(wb, `${nameProject}_Sparing_Trend_data_${moment(this.date_start).format('DD-MM-YYYY')}_${moment(this.date_finish).format('DD-MM-YYYY')}.xlsx`)
      })
    },
    exportExcelBattery() {
      useJwt.getProfile().then(response => {
        const nameProject = response.data.data.project[0].project_name
        if (this.select_device === 1083) {
          this.select_device = 'TSS'
        }
        if (this.select_device === 1081) {
          this.select_device = 'PH'
        }
        if (this.select_device === 1084) {
          this.select_device = 'NH3N'
        }
        if (this.select_device === 1082) {
          this.select_device = 'COD'
        }
        if (this.select_device === 1085) {
          this.select_device = 'Debit'
        }
        const jsons = []
        // eslint-disable-next-line no-plusplus
        for (let x = 0; x < this.historical_battery.length; x++) {
          jsons[x] = {
            Project: `${nameProject}_Trend`,
            Parameter: this.select_device,
            datetime: moment(String(this.historical_battery[x].datetime)).format('DD-MM-YYYY HH:mm:ss'),
            value: this.historical_battery[x].value + this.historical_battery[x].value_default_unit,
          }
        }
        const dataJson = XLSX.utils.json_to_sheet(jsons)
        const wb = XLSX.utils.book_new()
        XLSX.utils.book_append_sheet(wb, dataJson, 'data')
        XLSX.writeFile(wb, `${nameProject}_Battery_data_${moment(this.date_start).format('DD-MM-YYYY')}_${moment(this.date_finish).format('DD-MM-YYYY')}.xlsx`)
      })
    },
  },
}
</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
<style lang="scss">
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>
